var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbTextbox',{class:_vm.baseClass,attrs:{"value":_vm.formValue.config.url,"type":"url","autocomplete":"off","help":_vm.messages.url.help,"error":_vm.getErrorMessage,"disabled":_vm.disabled,"data-test":"promotion-url-textbox","label":_vm.messages.url.label,"required":""},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }